export default {
    loading: {
      show: false,
      message: ''
    },

    alert: {
      show: false,
      type: 'success',
      message: ''
    }
}
